import React from "react";
import { Link } from "react-router-dom";

// Text-based brand mark for Ocean Energy Industrial
export default function Logo({ light = false }) {
  const main = light ? "#ffffff" : "#16265c";
  const sub = light ? "rgba(255,255,255,0.85)" : "#16265c";
  return (
    <Link to="/" className="flex flex-col leading-none select-none" aria-label="Ocean Energy Industrial home">
      <span
        className="oe-display text-[20px] md:text-[22px] flex items-center gap-1"
        style={{ color: main }}
      >
        OCEAN
        <span
          className="inline-block w-2.5 h-2.5 rounded-full"
          style={{ backgroundColor: "#e2231a" }}
        />
        ENERGY
      </span>
      <span
        className="text-[10px] md:text-[11px] tracking-[0.42em] font-semibold pt-0.5"
        style={{ color: sub, borderTop: `2px solid ${main}` }}
      >
        INDUSTRIAL
      </span>
    </Link>
  );
}
